import { FC } from 'react';
import classNames from 'classnames';
import { Options } from 'src/components/CustomCalendar/types';
import { useTranslation } from 'react-i18next';

interface DropdownItemProps {
  onClick: (item: Options) => void;
  dropdownTextOrientation?: 'center' | 'left';
  item: Options;
}

// Вернуться и убрать здесь t, когда будет переписан языковой роутинг.
// Сейчас если убрать { t }, то options не переводятся
export const DropdownItem: FC<DropdownItemProps> = ({ dropdownTextOrientation, onClick, item }) => {
  const { t } = useTranslation();
  return (
    <li className="w-full">
      <button
        onClick={() => onClick(item)}
        type="button"
        className={classNames(
          'text-[14px] font-medium text-i_text capitalize cursor-pointer py-2 px-5 w-full r_xsm:px-2.5 hover:!text-i_dropdown_bg hover:bg-i_dropdown_hover',
          dropdownTextOrientation === 'left' ? 'text-left' : 'text-center'
        )}>
        {typeof item === 'string' ? t(item) : item}
      </button>
    </li>
  );
};
